import { proxy } from 'valtio';

import type { CountryCode } from '@/graphql/saleor/api';
import { getLocalWishlistByCountry } from '@/views/WishListView/utils';
export interface WishlistState {
  isHighlighted: boolean;
}

export const initialWishlistState: WishlistState = {
  isHighlighted: false,
};
export const wishListState = proxy<WishlistState>({ ...initialWishlistState });

export const wishlistActions = {
  updateIsHighlighted: (countryCode: CountryCode) => {
    const localWishlist = getLocalWishlistByCountry(countryCode);
    wishListState.isHighlighted =
      !!localWishlist && Object.keys(localWishlist)?.length > 0;
  },

  clear: () => {
    Object.keys(initialWishlistState).forEach((key) => {
      wishListState[key as keyof WishlistState] =
        initialWishlistState[key as keyof WishlistState];
    });
  },
};
